<template>
  <div class="my-card-voucher">
    <div class="card-voucher-wrapper" v-show="ticketList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div class="card-list">
          <div :key="index" class="card-details" v-for="(ticket, index) in ticketList">
            <a
              @click="jumpDetails(ticket.item_id, ticket.sku_id, ticket.platform)"
              class="jump-details"
              href="javascript:;"
            >
              <div class="card-img van-hairline--surround">
                <img v-lazy="ticket.pic_url" />
              </div>
              <div class="card-intro">
                <div class="name">{{ticket.name}}</div>
                <div class="platform">{{ticket.platform_info.brand}}</div>
              </div>
            </a>
            <button @click="showDetailsHandler(ticket.id)" class="cards-close">提取卡密</button>
          </div>
        </div>
      </list>
    </div>
    <div class="no-data" v-show="noData && !ticketList.length">
      <img alt src="../../assets/img/no-card.png" />
      <p>暂无购买卡券记录</p>
      <button @click="$router.push({name: 'home'})">去购物</button>
    </div>
    <camilo-details :ticket-details="ticketDetails" @close="closeDetails" v-model="showDetails"></camilo-details>
  </div>
</template>

<script>
import { list } from 'vant'
import CamiloDetails from '../coupons/CamiloDetails'
let flag = false
let sign = false
export default {
  name: 'myCardVoucher',
  components: {
    list,
    CamiloDetails
  },
  data () {
    return {
      showDetails: false,
      ticketList: [],
      loading: false,
      finished: false,
      pageNum: 1,
      noData: false,
      ticketDetails: {}
    }
  },
  computed: {
    platformName (platform) {
      return (platform) => {
        switch (platform) {
          case 'elianmeng':
            return 'E联盟'
        }
      }
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getTicketList(this.pageNum).then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getTicketList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    async getTicketList (pageNum) {
      const res = await this.$axios.get(`api/order/cards/${pageNum}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.ticketList = [...this.ticketList, ...data]
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },
    async getTicketDetails (id) {
      this.$toast.loading({
        message: '正在加载...',
        duration: 30000
      })
      const res = await this.$axios.get(`api/order/info/${id}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.ticketDetails = data
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },
    async showDetailsHandler (id) {
      if (sign) {
        return
      }
      sign = true
      const status = await this.getTicketDetails(id)
      if (status) {
        this.showDetails = true
      }
      sign = false
    },
    closeDetails () {
      this.showDetails = false
    },
    jumpDetails (goodsid, skuid, platform) {
      this.$router.push({ name: 'productDetails', query: { goodsid, skuid, platform } })
    }
  }
}
</script>

<style lang="less" scoped>
.card-voucher-wrapper {
  margin: 0.2rem 0;
  background-color: #fff;
}
.card-list {
  padding: 0 0.2rem;
  .card-details {
    position: relative;
    padding: 0.38rem 0 0.33rem;
    font-size: @fz24;
    border-bottom: 0.5px solid #dadada;
    .jump-details {
      display: flex;
      align-items: center;
    }
    .card-img {
      width: 2rem;
      height: 2rem;
      margin: 0 0.2rem;
      img {
        object-fit: contain;
      }
    }
    .card-intro {
      width: 3.03rem;
      height: 1.8rem;
      .flex-column-between;
      .name {
        color: @base;
      }
      .platform {
        color: #9f9f9f;
      }
    }
    .cards-close {
      position: absolute;
      right: 0.2rem;
      bottom: 0.45rem;
      width: 1.7rem;
      height: 0.68rem;
      border: 0.5px solid #979797;
      font-size: @fz24;
      color: @base;
      border-radius: 30px;
    }
  }
}
.no-data {
  width: 4.49rem;
  height: 3.08rem;
  margin: 2rem auto 0;
  text-align: center;
  font-size: @fz28;
  color: @base;
  p {
    margin: -0.6rem 0 0.62rem;
  }
  button {
    width: 1.93rem;
    height: 0.6rem;
    border: 0.5px solid #979797;
    font-size: @fz24;
    border-radius: 30px;
    background-color: #fff;
  }
}
</style>
